import { usePaywallList } from "@circle-react/hooks/paywalls/usePaywallList";
import type { Editor } from "@tiptap/core";

const getStringAttr = (attrs: Record<string, unknown>, key: string): string => {
  const value = attrs[key];
  return typeof value === "string" ? value : "";
};

const getNumAttribute = (
  attrs: Record<string, unknown>,
  key: string,
): number | null => {
  const value = attrs[key];
  return typeof value === "number" ? value : null;
};

export const usePaywallSettingsData = (editor: Editor | null) => {
  const { paywallsListQuery } = usePaywallList({
    status: ["active"],
    options: { enabled: !!editor },
  });
  const paywalls = paywallsListQuery.data ?? [];

  if (!editor) return null;

  const isEdit = editor.isActive("paywall");
  const existingAttrs: Record<string, unknown> = isEdit
    ? editor.getAttributes("paywall")
    : {};

  return {
    paywalls,
    isEdit,
    isPending: paywallsListQuery.isPending,
    isError: paywallsListQuery.isError,
    defaultValues: {
      paywall_id: getNumAttribute(existingAttrs, "paywall_id"),
      title: getStringAttr(existingAttrs, "title"),
      description: getStringAttr(existingAttrs, "description"),
      button_text: getStringAttr(existingAttrs, "button_text"),
    },
  };
};
